<template>
  <TransitionGroup class="suggestions" name="list-transform" tag="div">
    <ButtonGroup
      v-for="suggestion in suggestions"
      :key="suggestion"
      class="list-transform-item suggestions__item"
    >
      <ElButton
        type="primary"
        plain
        size="mini"
        icon="el-icon-delete"
        @click.native="reject(suggestion)"
      />
      <ElButton
        type="primary"
        plain
        size="mini"
        icon="el-icon-plus"
        @click="add(suggestion)"
      >
        {{ suggestion }}
      </ElButton>
    </ButtonGroup>
  </TransitionGroup>
</template>
<script>
import ButtonGroup from 'element-ui/lib/button-group';

export default {
  name: 'Suggestions',
  components: {
    ButtonGroup,
  },
  props: {
    suggestions: {
      required: true,
      type: Array,
    },
  },
  methods: {
    add(suggestion) {
      this.$emit('add', suggestion);
    },
    reject(suggestion) {
      this.$emit('reject', suggestion);
    },
  },
};
</script>

<style lang="scss">
.suggestions {
  &__item {
    margin-bottom: $global-margin / 2;

    &:not(:last-child) {
      margin-right: $global-margin;
      @include rtl() {
        margin-right: auto;
        margin-left: $global-margin;
      }
    }
  }
}
</style>
